import type { PropsWithChildren } from 'react';
import type { Layout } from '@mentimeter/http-clients';
import { Box } from '@mentimeter/ragnar-ui/box';
import { SfinxBackground } from './SfinxBackground';
import { SideBySideImage } from './SideBySideImage';

const SlidePadding = ({ children }: PropsWithChildren) => {
  return (
    <Box
      width="100%"
      height="100%"
      py="112px"
      px="space16"
      justifyContent="center"
      alignItems="center"
    >
      {children}
    </Box>
  );
};

interface SlideImageLayoutProps {
  image: {
    url: string | undefined;
    altText: string | undefined;
  };
  layoutType: Layout['type'] | undefined;
  layoutSize: Layout['size'] | '35%' | undefined;
  overrideToFullBackgroundImageWithSize?: false | 'cover' | 'contain';
}

// This component is WIP, moving stuff from Sfinx to here and refactoring as we go.
export const SlideImageLayout = ({
  image,
  layoutType,
  layoutSize,
  overrideToFullBackgroundImageWithSize = false,
  children,
}: PropsWithChildren<SlideImageLayoutProps>) => {
  if (!image.url) {
    return <SlidePadding>{children}</SlidePadding>;
  }

  const isSideBySide =
    layoutType === 'side-by-side' || layoutType === 'side-by-side-right';

  if (isSideBySide) {
    return (
      <SlidePadding>
        <SideBySideImage
          imageUrl={image.url}
          imageAltText={image.altText}
          layoutType={layoutType}
          imageWidth={layoutSize}
        >
          {children}
        </SideBySideImage>
      </SlidePadding>
    );
  }

  return (
    <SfinxBackground
      altText={image.altText}
      imageUrl={image.url}
      layoutType={layoutType}
      // temporary fix for 35% layout size, this should never happen
      layoutSize={layoutSize === '35%' ? '33%' : layoutSize}
      overrideToFullBackgroundImageWithSize={
        overrideToFullBackgroundImageWithSize
      }
    >
      <SlidePadding>{children}</SlidePadding>
    </SfinxBackground>
  );
};
